export const linkifyText = (text) => {
  
  const specialWordRegex = /%%\w+/g;
  
  const urlRegex = /(https:\/\/[^\s]+)/g;


  return text.split(urlRegex).map((part, index) => {
    
    if (part.match(urlRegex)) {
      try {
        const urlObj = new URL(part);
        console.log()
        const displayText = `${urlObj.hostname}${urlObj.pathname}`;
        return (
          <a
            key={index}
            href={part}
            target={part.split('/')[2] !== 'cristianherreradev-ruby.vercel.app' && '_blank'}
            rel="noopener noreferrer"
          >
            {'Click here'}
          </a>
        );
      } catch (error) {
        return part;
      }
    } else {
      return part;
    }
  });
};

export const chatArray = [
  {
    question: ['cristian', 'herrera', 'cristian?', 'herrera?', 'information', 'information?', 'info', 'info?'],
    answer: `Cristian Herrera is a web developer based in Chichester, West Sussex, United Kingdom. On this page, you can find his contact details, projects, as well as his CV.`
   },

   {
    question: ['technologies', 'technologie', 'frameworks', 
                'framework', 'experience', 'experiences', 'languages', 'language',
                'technologies?', 'technology?', 'frameworks?', 
                'framework?', 'experience?', 'experiences?', 'languages?', 'language?'
              ],
    answer: `Cristian has professional experience with PHP (Laravel, Symfony), JavaScript (Node.js, React), and Python, as well as Bootstrap and Tailwind. He works with Linux servers, Docker, WordPress, Git, Arduino, and Raspberry Pi, and has experience using MariaDB, PostgreSQL and MongoDB.`
   },
   {
    question: ['help', 'support', 'human', 'urgency','assistance',
               'help?', 'support?', 'human?', 'urgency?', 'assistance?'   
              ],
    answer: `I'm a bot. Ask me anything and I'll try to help you. If you need a human, type "help!" and wait in the chat until you are assisted, or call Cristian at 07864 069428 .`
   },
   {
    question: ['help!'],
    answer: `I’ve asked Cristian to connect to this chat. Please wait. If he doesn’t respond, you can talk with me again, just type “bot” .`
   },
   {
    question: ['contact', 'contact?'],
    answer: `His telephone number is 07864 069428, and his email address is mail@cristianherrera.co.uk. Alternatively, you can fill out the contact form at https://cristianherreradev-ruby.vercel.app/#/contact `
   },
   {
    question: ['projects', 'project', 'portfolio', 'portfolios',
               'projects?', 'project?', 'portfolio?', 'portfolios?'
              ],
    answer: `You can view his projects at https://cristianherreradev-ruby.vercel.app/#/projects `
   },
   {
    question: ['how much', 'price', 'fee',
               'how much?', 'price?', 'fee?' 
              ],
    answer:`You need to talk to him about this. His telephone number is 07864 069428, and his email address is mail@cristianherrera.co.uk . Alternatively, you can fill out the contact form at 
            https://cristianherreradev-ruby.vercel.app/#/contact `
   },
   {
    question: ['bot'],
    answer: `Hello again, I’m the bot assistant for Cristian. Can I help you?`
   },
   {
    question: ['speak', 'speaks', 'speak?', 'speaks?'],
    answer: `Cristian speaks English and Spanish .`
   },
   {
    question: ['objetive', 'goals', 'objectives', 'goal',
               'objetive?', 'goals?', 'objectives?', 'goal?'
              ],
    answer: `Cristian Herrera’s objective is to help businesses save time and reduce production costs by developing automated software that improves their revenue.`
   },
   {
    question: ['visa', 'rights', 'visa?', 'rights?'],
    answer: `He has a visa and full rights to work in the UK.`
   },
   {
    question: ['1234'],
    answer: `I’m Cristian’s assistant bot. Can I help you? If you don’t want to talk with me, type “help!” and I will ask Cristian to join this chat.`
   },
   {
    question: ['cv', 'curriculum', 'cv?', 'curriculum?'],
    answer: `You can view his CV here: https://cristianherrera.co.uk/cristianherreracv `
   },
   {
    question: ['live', 'living', 'based', 'located',
               'live?', 'living?', 'based?', 'located?'
              ],
    answer: `He is based in Chichester, West Sussex, United Kingdom.`
   },
   {
    question: ['php', 'php?', 'laravel', 'laravel?', 'symfony', 
               'symfony?', 'sql', 'mariadb', 'sql?', 'mariadb?',
               'react', 'js', 'javascript', 'node', 'nodejs', 'mongo', 
               'mongodb', 'typescript','react?', 'js?', 'javascript?', 
               'node?', 'nodejs?', 'mongo?', 'mongodb?', 'typescript?', 'wordpress', 'wordpress?',
               'python', 'python?' 
              ],
    answer: `Please check his projects: https://cristianherreradev-ruby.vercel.app/#/projects` 
   }

  
   






];



